/* eslint-disable no-unused-vars */
import { cloneDeep } from "lodash";
import axios from "../../axios";
import { PaginationBlank } from "../../utils/types/Pagination";

const state = {
  levels: [],
  pagination: cloneDeep(PaginationBlank()),
};

const actions = {
  /**
   * Fetches all levels from the ERP system.
   *
   * @param {Object} context - The Vuex action context.
   * @param {Function} context.commit - The Vuex commit function.
   * @param {Object} query - The query parameters to be sent with the request.
   * @returns {Promise} - A promise that resolves with the response or rejects with an error.
   */
  async getAllLevels({ commit }, query) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/levels-erp/all?${new URLSearchParams(query)}`)
        .then((response) => {
          commit("SET_ALL_LEVELS", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * Sets the current page in the store.
   *
   * @param {Object} context - The Vuex action context.
   * @param {Function} context.commit - The Vuex commit function.
   * @param {number} currentPage - The current page number to set.
   */
  setCurrentPage({ commit }, currentPage) {
    commit("SET_CURRENT_PAGE", currentPage);
  },
};

const mutations = {
  SET_ALL_LEVELS(state, data) {
    state.levels = data.items || [];
    state.pagination = data.pagination || state.pagination;
  },
  SET_CURRENT_PAGE(state, currentPage) {
    state.pagination.current_page = currentPage;
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
